import { firebaseRecursosRepository } from '../../infrastructure/recursos/firebaseRecurso.repository'

export const getAll = async () => {
  const recursos = await firebaseRecursosRepository.obtenerRecursos()
  return recursos.docs.map(doc => {
    return {
      id: doc.id,
      nombre: doc.data().Nombre,
      destinatario: doc.data().Destinatario,
      descripcion: doc.data().Descripcion,
      link: doc.data().Link,
      etiquetas: doc.data().Etiquetas,
      imagen: doc.data().ImagenUrl,
    }
  })
}
